import React from 'react'

const DurexRichMedia = () => {
    return (
        <div dangerouslySetInnerHTML={{
            __html: `<!DOCTYPE html>
            <html lang="en">
            
            <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Document</title>
            </head>
            
            <body>
                <!-- Ad chat -->
            
                <script data-creative-id='50807-51038-51370-65247' data-timestamp='2024-04-19T12:17:10.269Z'>
                    (function () {
                        var s = document.createElement('script');
                        s.src = 'https://delivery-3.cavai.com/assets/creatives/65247/cltikoxiz0236k5j4gxhk8bnd/built/assets/stub.js?bust=' + Date.now();
                        s.async = true;
                        s.setAttribute('data-click-macro', '{CLICK_URL}');
                        s.setAttribute('data-domain', '{pageurl}');
                        s.setAttribute('data-dsp', 'ZEM');
                        document.head.appendChild(s);
                    })();
                </script>
            
                <!-- Scratch -->
                <ins class="adcads" data-adc-id="j2bUJi4LYLtk" data-unit="j2bUJi4LYLtk" data-clickable="yes" data-redir="yes"
                    data-click-tracker="[ADS_CLICK_URL]" data-click-macro="[ADS_CLICK_URL]" data-has-desktop="yes"
                    data-responsive="yes" data-width="300" data-height="300">
                    <script src="https://media.adcanvas.com/j2bUJi4LYLtk/adtag.js" type="text/javascript" async></script>
                </ins>
            
                <!-- Queue -->
                <ins class="adcads" data-adc-id="g2gLKxYo7qAV" data-unit="g2gLKxYo7qAV" data-clickable="yes" data-redir="yes"
                    data-click-tracker="[ADS_CLICK_URL]" data-click-macro="[ADS_CLICK_URL]" data-has-desktop="yes"
                    data-responsive="yes" data-width="300" data-height="300">
                    <script src="https://media.adcanvas.com/g2gLKxYo7qAV/adtag.js" type="text/javascript" async></script>
                </ins>
            
            
            </body>
            
            </html>` }} className='block'></div>
    )
}

export default DurexRichMedia